import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";
import { isTruthy } from "@/utils/guards";
import VerticalDivider from "@/ui/molecules/VerticalDivider";

export type LayoutWithTopBarProps = BoxProps & {
    leftContent: React.ReactNode;
    rightContent: React.ReactNode;
    displayDivider?: boolean;
    middleContent?: React.ReactNode;
    displayVerticalDivider?: boolean;
    displayHorizontalDivider?: boolean;
};

const testId = "LayoutWithTopBar";
const LayoutWithTopBar = (props: LayoutWithTopBarProps) => {
    const {
        sx,
        children,
        className,
        leftContent,
        rightContent,
        middleContent,
        displayVerticalDivider = true,
        displayHorizontalDivider = true,
        ...otherProps
    } = props;

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
                backgroundColor: "var(--proda-white)",
                ...sx,
            }}
            {...otherProps}
        >
            <Box
                sx={{
                    zIndex: 1,
                    display: "flex",
                    alignItems: "center",
                    paddingTop: 1.5,
                    paddingLeft: 1,
                    paddingRight: 3,
                    paddingBottom: 1.5,
                    gap: "8px",
                    backgroundColor: "var(--proda-white)",
                    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.05)",
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        height: "2.5rem",
                    }}
                >
                    {leftContent}
                </Box>
                {displayVerticalDivider && <VerticalDivider />}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        flexGrow: 1,
                        height: "2.5rem",
                    }}
                >
                    {rightContent}
                </Box>
            </Box>
            {displayHorizontalDivider && (
                <Box
                    sx={{
                        width: "100%",
                        height: "1px",
                        backgroundColor: "var(--proda-white-130)",
                    }}
                />
            )}
            {isTruthy(middleContent) && (
                <Box
                    sx={{
                        width: "100%",
                        paddingTop: 1.5,
                        paddingLeft: 1,
                        paddingRight: 3,
                        paddingBottom: 1.5,
                        backgroundColor: "var(--proda-white)",
                    }}
                >
                    {middleContent}
                </Box>
            )}
            <Box
                sx={{
                    flexGrow: 1,
                    overflowY: "auto",
                    position: "relative",
                    flexShrink: 0,
                    zIndex: 0,
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

export default LayoutWithTopBar;
